<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="p-10 bg-lightwarning border border-lightgrey clearfix">
      按照模板要求填写各类成果记录，根据身份证号匹配教师信息，免审核导入成果记录。
      <a class="pull-right link-success m-l-20" @click="visible=true">
        <icon name="question-circle"></icon>
        查看批量导入说明
      </a>
    </div>
    <div class="list">
      <div class="item clearfix" v-for="type in types" :key="type.id">
        <div class="title">{{type.name}}</div>
        <div class="tools">
          <a :href="type.template_url" class="link-success">
            <icon name="download"></icon>
            下载模板
          </a>
          <a class="link-success">
            <select-file accept=".xls,.xlsx" @change="selectFile($event, type)"
                         :disabled="submit_loading>0" v-loading="submit_loading>0">
              <icon name="upload"></icon>
              选择文件导入
            </select-file>
          </a>
        </div>
      </div>
    </div>
    <TemplateGuideDialog :visible.sync="visible" :types="types"></TemplateGuideDialog>
  </div>
</template>

<script>
import * as Achievement from 'api/achievement'
import { BATCH_ACHIEVEMENT, ADMIN_BATCH_ACHIEVEMENT } from 'constants/storage_keys'
import { toJSON } from 'utils/lang'
import TemplateGuideDialog from './TemplateGuideDialog.vue'

export default {
  components: {TemplateGuideDialog},
  data () {
    return {
      ready: false,
      list: [],
      form: null,
      submit_loading: 0,
      visible: false,
    }
  },
  computed: {
    is_admin () {
      return this.$route.name === this.$location.admin_achievement_template_list().name
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [types] = await Promise.all([
          Achievement.types(),
        ])
        this.types = types
        this.ready = true
      })
    },
    selectFile (files, type) {
      this.$guard(this, 'submit_loading')(async () => {
        let data = await Achievement.upload({file: files[0], type: type.id})
        if (!data || !data.length) {
          this.$message('您上传的文件不包含成果信息，请检查')
          return
        }
        data.forEach(item => item.type = type.id)
        sessionStorage.setItem(this.is_admin ? ADMIN_BATCH_ACHIEVEMENT : BATCH_ACHIEVEMENT, toJSON(data))
        let route = this.is_admin ? this.$location.admin_achievement_batch_edit() : this.$location.achievement_batch_edit()
        this.$router.push(route)
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.item {
  background-color: $color-block-background;
  padding: 20px;
  margin: 10px 0;
  $color: mix($color-border, white, 20%);
  box-shadow: 1px 1px 5px -1px $color, -1px -1px 5px -1px $color;
  border: 1px solid mix($color-border, white, 20%);
  .title {
    color: black;
    float: left;
  }
  .tools {
    float: right;
    a {
      margin-left: 10px;
      &:first-child {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/AchievementTemplateList.vue